export default __webpack_public_path__ + "static/media/101.58790425.jpg";